module.exports = __webpack_public_path__ + "img/10.da12cac8.png";